import { FC } from 'react';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  UseDisclosureReturn,
} from '@chakra-ui/react';

import SunshineCard from 'components/_core/SunshineCard';
import SunshineIcon from 'components/_core/SunshineIcon';
import Header from 'features/Onboarding/components/Header';

import { isBeforeSeptember, lastYear } from '../../../helpers/dates';
import locales from './locales';

const RefusedDocumentsModal: FC<UseDisclosureReturn> = (props) => (
  <Modal {...props} scrollBehavior="inside">
    <ModalOverlay />
    <ModalContent
      alignSelf={{ base: 'flex-end', md: 'center' }}
      borderBottomRadius={{ base: 0, md: 'radius-8' }}
      borderTopRadius={{ base: 'radius-16', md: 'radius-8' }}
      marginY={0}
      paddingBottom="space-32"
      paddingTop="space-24"
      paddingX="space-24"
    >
      <ModalHeader borderBottom="none">
        <SunshineIcon
          color="grey.800"
          cursor="pointer"
          name="cross"
          onClick={() => props.onClose()}
          size="icon-18"
        />
      </ModalHeader>
      <ModalBody
        className="ModalBody"
        paddingLeft="space-16"
        paddingTop="space-12"
      >
        <Header
          description={locales.description}
          title={locales.nonAcceptedDocsLabel}
        />
        <SunshineCard.Group isBoxed={false}>
          {locales.nonAcceptedDocsList.map((text) => (
            <SunshineCard alignItems="center" key={text}>
              <SunshineCard.Slot name="aside">
                <SunshineIcon
                  color="grey.800"
                  marginRight="space-16"
                  name="forbidden"
                  size="icon-16"
                />
              </SunshineCard.Slot>
              <SunshineCard.Content>
                <SunshineCard.Text fontSize="font-15" variant="primary">
                  {text}
                </SunshineCard.Text>
              </SunshineCard.Content>
            </SunshineCard>
          ))}
          {!isBeforeSeptember ? (
            <SunshineCard alignItems="center">
              <SunshineCard.Slot name="aside">
                <SunshineIcon
                  color="grey.800"
                  marginRight="space-16"
                  name="forbidden"
                  size="icon-16"
                />
              </SunshineCard.Slot>
              <SunshineCard.Content>
                <SunshineCard.Text fontSize="font-15" variant="primary">
                  {locales.formatString(locales.incomeTaxNotice, {
                    lastYear: lastYear,
                  })}
                </SunshineCard.Text>
              </SunshineCard.Content>
            </SunshineCard>
          ) : null}
        </SunshineCard.Group>
      </ModalBody>
    </ModalContent>
  </Modal>
);

export default RefusedDocumentsModal;
